import { createActionCreator } from '@pressreader/appstore';
import { type OpenCommentsDialogAndWaitForResultOptions } from '@pressreader/comments-popups';
import type { IIssueInfo } from '@pressreader/content-types';
import { UserVote } from '@pressreader/social-types';

import { MODULE_NAME } from '../../constants';
import type { ArticleSocialMetadata } from '../../types';

const prefix = `${MODULE_NAME}/social/`;

export const commentRequestAction = createActionCreator<{
    articleId: string;
    primaryArticleId: string | undefined;
}>(`${prefix}comment-request`);

export const voteForArticleAction = createActionCreator<{
    articleId: string;

    type: UserVote;
}>(`${prefix}vote-for-article`);

export const articleCommentsMetadataUpdated = createActionCreator<{
    articleId: string;
    commentsMetadata: {
        totalCount: number;
    };
}>(`${prefix}comments-metadata-updated`);

export const articleCommentsOpenDialogAndPublishCommentsMetadataAction = createActionCreator<
    Omit<OpenCommentsDialogAndWaitForResultOptions, 'issueCidDateKey'> & {
        articleId: string;
        primaryArticleId: string | undefined;
        issueCidDateKey?: IIssueInfo['issueCidDateKey'];
    }
>(`${prefix}comments-open-dialog-and-publish-comments-metadata-action`);

export const articleSocialMetaUpdated = createActionCreator<{
    articleSocialMetaUpdates: Array<{
        articleId: string;
        socialMetadataUpdate: Partial<ArticleSocialMetadata>;
    }>;
}>(`${prefix}article-social-meta-updated`);
